import SEO_CONFIG from "@/config/seo.config.json";
import socialLinks from "@/config/socialLinks";

export default {
  langList: window._langListData || [],
  tg: socialLinks.tg,
  x: socialLinks.x,
  tiktok: socialLinks.tiktok,
  medium: socialLinks.medium,
  youtube: socialLinks.youtube,
  instagram: socialLinks.instagram,
  linktree: socialLinks.linktree,
  seo: SEO_CONFIG.content,
};
